import type { CentreData } from './types';

export const colebeeData: CentreData = {
  slug: 'colebee',
  name: 'Schoolola Colebee',
  suburb: 'Colebee',
  region: 'Western Sydney',
  state: 'NSW',
  stateName: 'New South Wales',
  status: 'operational',
  yearLevels: 'Kindergarten - Year 8',
  canonicalPath: '/centres/colebee/',
  heroImage: 'https://schoolola.com.au/centres/colebee-og.jpg',
  address: {
    street: '7/88 Stonecutters Drive',
    city: 'Colebee',
    postcode: '2761',
    lat: -33.7014,
    lng: 150.8736,
  },
  contact: {
    phone: '0494 168 107',
    phoneHref: '+61494168107',
    email: 'colebee@schoololatutoring.com.au',
  },
  hours: {
    monday: { opens: '15:00', closes: '21:00' },
    tuesday: { opens: '15:00', closes: '21:00' },
    wednesday: { opens: '15:00', closes: '21:00' },
    thursday: { opens: '15:00', closes: '21:00' },
    friday: { opens: '15:00', closes: '21:00' },
    saturday: { opens: '10:00', closes: '14:00' },
    sunday: null,
  },
  heroSubtitle:
    'OC, selective school and NAPLAN preparation by qualified NSW Curriculum teachers using the proven TMRW™ methodology.',
  trustStrip: [
    { k: 'In-person', v: '7/88 Stonecutters Drive' },
    { k: 'Kindergarten - Year 8', v: 'All primary year levels' },
    { k: 'NSW Curriculum', v: 'Qualified teachers' },
  ],
  breadcrumb: { regionLabel: 'Western Sydney' },
  googleRating: {
    value: 5.0,
    count: 25,
    profileUrl: 'https://www.google.com/search?q=Schoolola+Colebee',
  },
  reviews: [
    {
      author: 'Reenu Raju',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-25',
      body: "Highly recommend Schoolola Tutoring! Our child has been attending Year 1 maths tuition at Schoolola, and we've seen a real improvement in their confidence and understanding. The tutors are wonderful and keep parents updated on progress.",
    },
    {
      author: 'Rosi Hooda',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-25',
      body: "We can't thank Schoolola Colebee enough for the difference they've made in our child's learning journey. Since joining, our little one has not only improved academically but has also grown so much in confidence. The teachers are warm, patient, and genuinely care about every child's progress. It's such a positive and encouraging environment - our child looks forward to every class! We feel truly blessed to have found this amazing tuition centre for primary students.",
    },
    {
      author: 'Jyoti Raychandani',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-22',
      body: "Schoolola Tutoring in Colebee has been an amazing experience. The environment is modern, safe, and welcoming, and the tutors are patient, knowledgeable, and genuinely care about each student's progress. They adapt their teaching methods so students feel confident and supported. The facilities are excellent, with bright classrooms, great resources, and a professional yet child-friendly atmosphere. Highly recommend Schoolola Colebee to anyone looking for quality tutoring and a supportive learning space!",
    },
    {
      author: 'Paramvir Khicher',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-20',
      body: "My son really enjoys going to this coaching centre. Teachers are kind and explain things clearly. He's learning well and feels more confident now, especially in maths and English. Very happy with the support of teachers and atmosphere here. Thank you!",
    },
    {
      author: 'Manmeet Kaur',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-18',
      body: 'Highly recommend. Provides excellent services for primary students. Teachers are well qualified and give personal attention to kids. Teachers also provide weekly review and stay in constant touch with the parents.',
    },
    {
      author: 'Kanika Dua',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-15',
      body: "Highly recommend Schoolola for young kids' learning journey. Their team is professional and very supportive and explains concepts in the way it makes sense to the kids. I have noticed much improvement in my kids since they started learning here. Very, very happy with the knowledgeable teachers. Thank you to the whole team!",
    },
    {
      author: 'Kartik Lamba',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-12',
      body: 'This tutoring school delivers excellent academic support. The tutors are professional, patient, and effective, helping students achieve noticeable improvement in both confidence and results.',
    },
    {
      author: 'Sandeep Sehrawat',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-10',
      body: "My kids love this tuition centre. It's fun, interactive and moreover, educational. I recommend this tuition centre to all.",
    },
    {
      author: 'Aliya Topal',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-04-15',
      body: "I have been to a lot of places and actually lost hope in my son's ability to learn. But when we found this place and my son has been continuing now for a year, he has excelled exceptionally well. I love how they alter things to your child's needs. Love this place, the people and also the strategy they have put in place for my child to do well. Thank you!",
    },
    {
      author: 'Kanu Mehrok',
      rating: 4,
      timeAgo: 'a year ago',
      datePublished: '2025-04-10',
      body: "This tutoring centre was probably one of the best decisions I made in the last few months for my daughter. Their teachers are very hardworking and dedicated to improving every individual student's progress. I highly recommend Schoolola.",
    },
    {
      author: 'Bob S',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-10',
      body: 'The school has a strong sense of community, and students feeling safe and supported. Very educated teachers where students gain knowledge. Supportive environment, highly recommend Schoolola.',
    },
    {
      author: 'Harman Singh',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-05',
      body: "My daughter recently joined the after-school course at Schoolola tuition, we've been so impressed her confidence and understanding have grown immensely. Thank you Schoolola!",
    },
    {
      author: 'Rupanshi Hooda',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-05',
      body: 'Schoolola Tutoring in Colebee boosts K-6 learning with engaging programmes and smart tools for NAPLAN and Selective exam success.',
    },
    {
      author: 'M&M&M',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-04-05',
      body: 'Great communication with the parents, flexibility with timings and my 6-year-old is always so excited to attend his class. Tanvi is very patient and really supportive towards him and he loves attending the classes.',
    },
    {
      author: 'Soni Lohan',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-01',
      body: 'Highly recommended for primary students, teachers are well qualified and give personal attention to kids. Thank you to the whole team.',
    },
    {
      author: 'Johnn Panlilio',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-04-01',
      body: "Excellent tutor teachers. Clear, patient, and highly effective. Highly recommend! Especially if you're in the area. Very flexible and catering to specific subjects English and Maths. Great for OC and selective preparations.",
    },
    {
      author: 'Komal Mehta',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-28',
      body: 'Very good service, very good staff, loved it!',
    },
    {
      author: 'Lynda Zerkowski',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-03-28',
      body: 'The small class size provides a more tailored experience.',
    },
    {
      author: 'Nithya Swaminathan',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-03-20',
      body: 'Great tutorial centre with excellent knowledge of educators.',
    },
    {
      author: 'Cricket Lovers',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-15',
      body: 'Highly recommended!',
    },
    {
      author: 'Ripandeep Kaur Bhathal',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-08',
      body: 'Excellent tuition centre with a wonderful team. Highly recommend Schoolola Colebee for primary students.',
    },
    {
      author: 'Bandana Rani',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-18',
      body: 'Wonderful experience with Schoolola Tutoring. The team genuinely cares about every child and the progress shows.',
    },
    {
      author: 'Gaming Player',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-03-15',
      body: 'Highly recommend Schoolola Colebee. Great teachers and a supportive learning environment.',
    },
  ],


  suburbsServed: ['Colebee', 'Marsden Park', 'Glendenning', 'Dean Park'],
  programs: [
    {
      id: 'oc',
      title: 'OC TMRW™ Preparation',
      yearPill: { label: 'Yr 3 - 4', tone: 'info' },
      tagline: 'Comprehensive OC exam preparation with proven TMRW™ strategies',
      bullets: ['Thinking Skills', 'Mathematical Reasoning', 'Reading'],
      educationalLevel: 'Year 3 to Year 4',
      description: 'Comprehensive OC exam preparation for primary students using the proven TMRW™ methodology, with practice tests and structured strategy training.',
      featured: 'popular',
    },
    {
      id: 'selective',
      title: 'Selective TMRW™ Preparation',
      yearPill: { label: 'Yr 5 - 6', tone: 'info' },
      tagline: 'Expert coaching for selective school entrance examinations',
      bullets: ['Thinking Skills', 'Mathematical Reasoning', 'Reading', 'Writing'],
      educationalLevel: 'Year 5 to Year 6',
      description: 'Expert coaching for selective school entrance examinations, specialised for primary students using the TMRW™ methodology.',
    },
    {
      id: 'foundations',
      title: 'Foundations Course',
      yearPill: { label: 'K - Year 8', tone: 'success' },
      tagline: 'Core English and maths · all primary year levels',
      bullets: ['Phonics, fluency, comprehension', 'Number sense to fractions', 'Writing structure across genres'],
      educationalLevel: 'Kindergarten to Year 8',
      description: 'Core English and mathematics tutoring for Kindergarten through Year 8 students, aligned to the NSW Curriculum.',
    },
    {
      id: 'naplan',
      title: 'NAPLAN Preparation',
      yearPill: { label: 'Yr 3, 5', tone: 'info' },
      tagline: '10-week term aligned to ACARA',
      bullets: ['Reading and writing', 'Numeracy strategies', 'Language conventions'],
      educationalLevel: 'Year 3 and Year 5',
      description: '10-week term NAPLAN preparation course covering reading, writing, language conventions and numeracy, aligned to ACARA test specifications.',
    },
  ],
  differentiators: [
    {
      title: 'NSW Curriculum specialists',
      body: "Our team maps lessons to what your child's school actually teaches, not generic worksheets.",
      icon: 'BookOpen',
    },
    {
      title: 'Measurable progress reports',
      body: 'Regular assessments tracked against ACARA bands. Parents see exactly where their child sits.',
      icon: 'LineChart',
    },
    {
      title: 'Small group ratios',
      body: 'Small group sizes for genuine individual attention while keeping the energy of peer learning.',
      icon: 'Users',
    },
    {
      title: 'OC and Selective track record',
      body: 'Students placed at Penrith High, Girraween High and other Western Sydney selective schools.',
      icon: 'Trophy',
    },
  ],
  faqs: [
    {
      question: 'What year levels do you tutor in Colebee?',
      answer: 'Kindergarten through Year 8. Foundations covers all primary year levels in English and maths; OC, Selective and NAPLAN programmes target specific testing years.',
    },
    {
      question: 'Where is the Colebee centre located?',
      answer: 'Schoolola Colebee operates from 7/88 Stonecutters Drive, Colebee NSW 2761.',
    },
    {
      question: 'What are your operating hours in Colebee?',
      answer: 'Monday to Friday from 3:00 PM to 9:00 PM, and Saturday from 10:00 AM to 2:00 PM.',
    },
    {
      question: 'What does the free assessment include?',
      answer: 'A full diagnostic assessment, a 1:1 parent consultation, and a written learning plan with the recommended programme.',
    },
  ],
};
